<template>
  <v-layout wrap justify-center align-center px-2>
    <v-flex xs12>
      <v-layout wrap ref="layout">
        <v-flex v-for="(item, index) in shownImages" :key="index" xs4 sm3 md2 lg1 d-flex child-flex>
          <v-card hover class="d-flex">
            <img
              :src="item.url[0]"
              aspect-ratio="1"
              class="grey lighten-2"
              style="cursor: pointer; width: 100%; height: 100%"
              @click="handleImageClick(index)"
            />
<!--              <template v-slot:placeholder>-->
<!--                <v-layout fill-height align-center justify-center ma-0>-->
<!--                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>-->
<!--                </v-layout>-->
<!--              </template>-->
<!--            </img>-->
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <ImageGalleryDialog
      :show="showImageGallery"
      :continuous="continuousCarousel"
      :currentIndex="imageGalleryIndex"
      :images="images"
      @changedIndex="changedIndex"
      @closed="showImageGallery = false"
    />
  </v-layout>
</template>

<script>
import ImageGalleryDialog from './Dialog.vue';

export default {
  data: () => ({
    showImageGallery: false,
    imageGalleryIndex: 0,
    continuousCarousel: false,
  }),
  props: {
    images: Array,
  },
  computed: {
    shownImages() {
      return this.$props.images;
    },
  },
  components: { ImageGalleryDialog },
  methods: {
    handleImageClick(index) {
      console.log(this.images);
      this.imageGalleryIndex = index;
      this.showImageGallery = true;
    },
    changedIndex(index) {
      this.imageGalleryIndex = index;
    },
  },
};
</script>
